import { apiSlice } from './apiSlice';
import { STORESTOCKS_URL } from '../constants';

export const storeStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new storeStock
    createStoreStock: builder.mutation({
      query: (storeStock) => ({
        url: STORESTOCKS_URL,
        method: 'POST',
        body: storeStock,
      }),
    }),

    // Get storeStock details by ID
    getStoreStockDetails: builder.query({
      query: (id) => ({
        url: `${STORESTOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's storeStocks
    getMyStoreStocks: builder.query({
      query: () => ({
        url: `${STORESTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all storeStocks (Admin)
    getStoreStocks: builder.query({
      query: () => ({
        url: STORESTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark storeStock as delivered
    deliverStoreStock: builder.mutation({
      query: (storeStockId) => ({
        url: `${STORESTOCKS_URL}/${storeStockId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete storeStock
    deleteStoreStock: builder.mutation({
      query: (storeStockId) => ({
        url: `${STORESTOCKS_URL}/${storeStockId}`,
        method: 'DELETE',
      }),
    }),

    // Update storeStock (FIXED)
    updateStoreStock: builder.mutation({
      query: ({ storeStockId, ...body }) => ({
        url: `${STORESTOCKS_URL}/${storeStockId}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useCreateStoreStockMutation,
  useGetStoreStockDetailsQuery,
  useGetMyStoreStocksQuery,
  useGetStoreStocksQuery,
  useDeliverStoreStockMutation,
  useDeleteStoreStockMutation,
  useUpdateStoreStockMutation,
} = storeStocksApiSlice;
